export const SET_DEALER_DATA = 'SET_DEALER_DATA';
export const SET_DEALER_LOGO_URL = 'SET_DEALER_LOGO_URL';



// WEBPACK FOOTER //
// ./src/store/reducers/dealerData/actionTypes.js